import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.063 12.531a.56.56 0 0 0-.407.172.56.56 0 0 0-.172.406v2.579h-3.39a.56.56 0 0 0-.406.171.52.52 0 0 0-.172.407q0 .234.172.406t.406.172h1.219V26.89q0 .234.171.406a.57.57 0 0 0 .422.172h10.328a.56.56 0 0 0 .407-.172.56.56 0 0 0 .172-.406V16.844h1.108a.56.56 0 0 0 .407-.172.56.56 0 0 0 .172-.406.52.52 0 0 0-.172-.407.56.56 0 0 0-.406-.171h-3.406v-2.579a.56.56 0 0 0-.172-.406.56.56 0 0 0-.407-.172zm.578 3.156v-2h4.718v2zm-2.157 10.626v-9.47h9.172v9.47zm3.141-7.047a.4.4 0 0 0-.187-.11.45.45 0 0 0-.204-.047.56.56 0 0 0-.406.172.56.56 0 0 0-.172.407q0 .108.032.218.045.094.125.172l1.359 1.36-1.36 1.359a.6.6 0 0 0-.156.203.6.6 0 0 0-.047.234q0 .235.172.407a.57.57 0 0 0 .422.172.6.6 0 0 0 .235-.047.5.5 0 0 0 .187-.141L20 22.265l1.375 1.36q.078.095.188.14a.6.6 0 0 0 .234.047.57.57 0 0 0 .422-.171.56.56 0 0 0 .172-.407.46.46 0 0 0-.063-.234.5.5 0 0 0-.14-.203l-1.36-1.36 1.36-1.359a.44.44 0 0 0 .109-.172.555.555 0 0 0-.125-.625.56.56 0 0 0-.625-.125.44.44 0 0 0-.172.11L20 20.625z"
    }, null, -1),
    _createElementVNode("rect", {
      width: "38",
      height: "38",
      x: "1",
      y: "1",
      stroke: "currentColor",
      "stroke-width": "2",
      rx: "3"
    }, null, -1)
  ]))]))
}
export default { render: render }